export enum PropertyOptionId {
    House = 'House',
    Flat = 'flat',
}

export default PropertyOptionId;
